import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../constants/api'
import moment from 'moment'

const BillList = () => {

    const [bills, setBills] = useState([])
    const [pastBills, setPastBills] = useState([])
    const [loading, setLoading] = useState(false)
    const [loadingPdf, setLoadingPdf] = useState({})
    const [loadingPastBillPdf, setLoadingPastBillPdf] = useState({})

    const navigate = useNavigate()

    const isAdmin = localStorage.getItem('isAdminLogin') === 'true'

    const getAllBills = async () => {
        setLoading(true)
        try {
            const response = await api(isAdmin, '/getSlotBookingList', 'get')
            const responsePastBills = await api(isAdmin, '/getBills', 'get')
            console.log(response)
            setBills(response?.data)
            setPastBills(responsePastBills?.data.sort((a, b) => {
                const [monthA, yearA] = a.monthandYear.split('-');
                const [monthB, yearB] = b.monthandYear.split('-');
                
                const months = {
                    'January': 0, 'February': 1, 'March': 2, 'April': 3,
                    'May': 4, 'June': 5, 'July': 6, 'August': 7,
                    'September': 8, 'October': 9, 'November': 10, 'December': 11
                };
                
                const dateA = new Date(parseInt(yearA), months[monthA]);
                const dateB = new Date(parseInt(yearB), months[monthB]);
                
                return dateB - dateA;
            }));
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllBills()
    }, [])

    const loadGroundBookingBill = async (bill, index) => {
        try {
            console.log(bill)
            if (bill?.id) {
                setLoadingPdf({
                    ...loadingPdf, [index]: true
                })
                let response = await api(isAdmin, 'viewBillGround', "post", {
                    "memberId": parseInt(localStorage.getItem('MemberId')),
                    "categoryCode": null,
                    "memberCode": 0,
                    "memberName": null,
                    "memberAddress": null,
                    "gstNo": null,
                    "billNo": bill.id,
                    "billDate": bill.startTime,
                    "gameDetails": [
                        {
                            "gameName": "Ground",
                            "hsnCode": null,
                            "noofGames": 1,
                            "cgstPercentage": parseFloat(bill.cgst) || 2.5,
                            "sgstPercentage": parseFloat(bill.sgst) || 2.5,
                            "gameAmount": ((parseFloat(bill.amount || 0) * 100) / ( 100 + ( (parseFloat(bill.cgst) || 2.5) + (parseFloat(bill.sgst) || 2.5) )) )
                        }
                    ],
                    "advanceAmount": bill.status == 'success' ? parseFloat(bill.amount || 0) : 0,
                    "billComments": `Ground Booked on date ${moment(bill.startTime).format('DD/MM/YYYY')}`
                }, {
                    fromweb: "",
                }, {
                    responseType: 'blob'
                })
                console.log(response, ' <== I am api response')
                const url = window.URL.createObjectURL(response.data)
                console.log(url, ' <== = I am url')
                window.open(url);
                setLoadingPdf({
                    ...loadingPdf, [index]: false
                })
            } else {
                setLoadingPastBillPdf({
                    ...loadingPastBillPdf, [index]: true
                })
                let response = await api(isAdmin, `viewBill?billNo=${bill?.billNo}&monthAndYear=${bill?.monthandYear}`, "get", {}, {}, {
                    responseType: 'blob'
                })
                console.log(response, ' <== I am api response')
                const url = window.URL.createObjectURL(response.data)
                console.log(url, ' <== = I am url')
                window.open(url);
                setLoadingPastBillPdf({
                    ...loadingPastBillPdf, [index]: false
                })
            }
        } catch (e) {
            console.log(e)
        } finally {

        }

    }



    return (
        <div style={{ display: "flex", width: "100vw", height: "100vh", margin: 0, padding: 0, boxSizing: "border-box" }}>
            <div style={{ flex: 1, display: "flex", flexDirection: "column", height: "100vh", borderRight: "2px solid #eee", boxSizing: "border-box", padding: "20px 20px 0 20px" }}>
                <div style={{ fontWeight: "bold", fontSize: "28px", marginBottom: "10px", padding: "20px 20px 0 20px" }}>Ground Booking</div>
                <div style={{ flex: 1, overflowY: "auto", padding: "0 20px 20px 20px" }}>
                    {bills && bills.map((bill, index) => {
                        return <div
                            style={{ background: "#fff", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", padding: "20px", border: "2px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", paddingTop: "20px"}}
                        >
                            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }} >
                                <span>
                                    Date: {new Date(bill.startTime).toLocaleDateString()}
                                </span>
                                <span>
                                    Start-Time: {new Date(bill.startTime).toLocaleTimeString()}
                                </span>
                                <span>
                                    End-Time: {new Date(bill.endTime).toLocaleTimeString()}
                                </span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }} >
                                <span>
                                    Amount: {bill.amount || 0}
                                </span>
                                <span
                                    style={{
                                        color: bill.status === 'success' ? 'green' : (bill.status === 'failed' || bill.status === 'cancel') ? 'red' : 'inherit',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Status: {bill.status}
                                </span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }} >
                                <button disabled={loadingPdf[index] ? true : false} style={{ padding: "5px 15px", borderRadius: "6px", border: "1px solid #bbb", background: loadingPdf[index] ? "#eee" : "#f5f5f5", cursor: loadingPdf[index] ? "not-allowed" : "pointer" }} onClick={(e) => { e.preventDefault(); loadGroundBookingBill(bill, index) }} > {loadingPdf[index] ? 'Loading' : "View"} </button>
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div style={{ flex: 1, display: "flex", flexDirection: "column", height: "100vh", boxSizing: "border-box", padding: "20px 20px 0 20px" }}>
                <div style={{ fontWeight: "bold", fontSize: "28px", marginBottom: "10px", padding: "20px 20px 0 20px" }}>Past Bills</div>
                <div style={{ flex: 1, overflowY: "auto", padding: "0 20px 20px 20px" }}>
                    {pastBills && pastBills.map((bill, index) => {
                        return <div
                            style={{ background: "#fff", borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)", padding: "20px", border: "2px solid #eee", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}
                        >
                            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }} >
                                <span>
                                    Month-Year: {bill.monthandYear}
                                </span>
                                <span>
                                    Bill number: {bill.billNo}
                                </span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }} >
                                <button disabled={loadingPastBillPdf[index] ? true : false} style={{ padding: "5px 15px", borderRadius: "6px", border: "1px solid #bbb", background: loadingPastBillPdf[index] ? "#eee" : "#f5f5f5", cursor: loadingPastBillPdf[index] ? "not-allowed" : "pointer", marginLeft: "15px" }} onClick={(e) => { e.preventDefault(); loadGroundBookingBill(bill, index) }} > {loadingPastBillPdf[index] ? "Loading" : "View"} </button>
                            </div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    )
}

export default BillList